/**
 * @deprecated Use platform.constants.ts
 */

/**
 * @deprecated
 * Use "PLATFORMS" enum on domain/platform/platform.types.ts
 */
const ADS_PLATFORMS = {
    CLIENT: 'client',
    GOOGLE_ADS: 'google_ads',
    GOOGLE_ANALYTICS: 'google_analytics',
    FACEBOOK_ADS: 'facebook_ads',
};
export default ADS_PLATFORMS;
